// Toggle this to inject the simulation round instead of real spin data
// export const DEV_SIMULATION_ENABLED = false;
export const DEV_SIMULATION_ENABLED = false;

// Which simulated round to inject. Two are defined in this file:
//
//   "scatter_anticipation"  CLEOPATRA'S FIRE — three scatters (10) on reels 1, 3
//                     and 5, no win, NO trigger. For the per-reel scatter
//                     anticipation: reels 4 and 5 anticipate one by one. The
//                     free-spins trigger is deliberately NOT simulated — it
//                     would put the client in free spins while the server is
//                     not, and the next `freespin` would be an action outside
//                     available_actions (ban). Set DEV_SCATTER_ANTICIPATION_HIT
//                     false for the miss (only two scatters).
//   "coin_trails"     CLEOPATRA'S FIRE — three coins (reel 1 top, reel 3
//                     middle, reel 5 bottom) on EVERY spin, for tuning the coin
//                     → logo fire trail (Games/Shared/coinToLogoTrail). Three is
//                     under the anticipation's START_AT (4), so the reels stop
//                     normally. No win, no trigger.
//   "coin_anticipation"  CLEOPATRA'S FIRE — Hold & Win anticipation (GDD §6.2):
//                     2 coins on reel 1 and 2 on reel 2 (4 down), so the chain
//                     starts on reel 3. DEV_COIN_ANTICIPATION_COINS sets the
//                     total: 4 or 5 = a miss, reels 3, 4 and 5 anticipate;
//                     6 = reel 4 brings the 6th, the chain ends there and reel
//                     5 stops normally. No win, NO trigger (same ban reason as
//                     above).
//   "jackpot_coins"   CLEOPATRA'S FIRE — three jackpot coins (mini, major,
//                     grand) on every spin, for the plates' jackpot_<tier>_hit.
//                     No win, no trigger.
//   "hp_rows"         CLEOPATRA'S FIRE — the two MIDDLE rows all one high pay
//                     (DEV_HP_ROWS_SYMBOL: 1–4 = h1–h4), low pays on the top
//                     and bottom rows. For checking symbol positions. No win
//                     presented (`wins` empty), no trigger.
//   "big_win"         a 65x win that plays the full celebration tier chain
//   "scatter_trigger" the free-spins trigger board — 2 SC + the gamble
//                     scatter, with the reveal payload attached
//   "mystery_reveal"  fourteen stacked mystery symbols revealing into a mid
//                     pay, paying 25 lines — the B1 feature
//   "golden_mystery"  ten mysteries revealing into B2 (the bonus symbol), one
//                     coin per skin — the B1 -> B2 handover, the cascade and the
//                     Golden Mystery payout. SYNTHETIC: a board this big has
//                     never been seen live.
//   "golden_chain"    ROUND 1431382 VERBATIM — a real chain: a x3 multiplier and
//                     a collect across three iterations. The only capture we
//                     have of the loop
//   "golden_big"      the same SHAPE as that capture, widened: five cells, so a
//                     multiplier hits four coins and a collector gathers four.
//                     Synthetic, and says so
//   "golden_mult"     ONE multiplier and nothing else, as a single full reel:
//                     five coins, an x3 between them, and the respin it leaves
//                     behind. No collector, and one axis, so the multiplier is
//                     the only thing on screen to judge
//   "mystery_short"   the SAME B1 feature with a SMALL board, so the build-up
//                     is the 500ms `anticipation` instead of the 2000ms
//                     `anticipation_strong` — the clip is chosen from what the
//                     board threatens, not set
//   "golden_all"      EVERY symbol type in one spin — a multiplier, four coins,
//                     the collector, SC and SC1 — then both loop phases over
//                     them. The one to watch landings and bounces on
//   "scatter_blank"   TWO plain scatters and the GOLD one, all landing on the
//                     BOARD — no mystery, nothing revealing into them. The gold
//                     one opens, its strip spins and stops on the EMPTY window.
//                     The round to hear `scatter_lose` on
//   "golden_blank"    ROUND 1451830's SHAPE — a board SC, a second SC from the
//                     feature, and a BLANK SC1 from the feature. Three scatters,
//                     no trigger: the scatter opens, spins and lands on the
//                     empty window. The one gamble-scatter case a simulation can
//                     prove end to end
//   "win_trigger"     REGULAR LINE WINS + 3 SCATTERS, and nothing else. The
//                     "win + bonus trigger" combination that has broken in
//                     every game in this family. No feature involved, so a
//                     fault can only be the win/trigger interaction itself
//   "golden_full"     mystery_reveal's FOURTEEN coords, revealing into B2
//                     instead of a paying symbol — the biggest golden board,
//                     with a multiplier, a collector and twelve coins. Every
//                     golden sound in one spin. Short anticipation, and the
//                     round says why
//   "golden_max"      EVERY cell on the board golden — thirty of them, thirty
//                     coins, no multiplier and no collector so nothing chains.
//                     The LOAD round: what the feature costs at its ceiling.
//                     Use it with perf-probe.js, not to watch
//   "golden_quiet"    the SOUND round: six Golden cells in two groups, paying
//                     16x so it stays under the big-win threshold. The one to
//                     use for golden_mystery_spin, coin_land and
//                     golden_mystery_win, none of which can be judged on a
//                     board that plays a celebration over them
//   "golden_gamble"   a feature cell landing the GAMBLE SCATTER — the base-game
//                     branch of GDD §7's "Gamble Scatter present? -> start
//                     Gamble Round". Synthetic; the award half is deliberately
//                     not faked, see the round for why
//   "golden_reroll"   ROUND 1472920 VERBATIM — the big one. Four full reels of
//                     Golden cells, THREE magnets chaining into each other, a
//                     x2, a plain scatter and a BLANK gamble scatter that the
//                     server re-lists on every iteration, so it re-rolls four
//                     times. 951x. The round the re-roll, the reload strip and
//                     the swallowed-magnet rule were all found on
//   "golden_reroll_award"  THE SAME ROUND, but the scatter AWARDS on its last
//                     turn — 8 spins at level 3. Win AND trigger in one round:
//                     the feature runs, the window re-rolls blank three times,
//                     lands the package, the 9510 presents, then the scatters
//                     light and the gamble screen takes over
//   "golden_gamble_two"  TWO feature cells landing the gamble scatter in the
//                     same spin, which is what the reference game does and what
//                     this client has never been asked to draw. Watch what the
//                     SECOND one does: the reveal is claimed once per round
//                     (revealPlayedForRoundRef) and goldenGambleRevealCell
//                     returns a single cell, so only one window can open today
//
// The trigger one exists because buying or landing the bonus for real leaves
// `flow.state` on "gamble_freespins" until the round is collected or gambled,
// which blocks further base-game spins. The simulation reproduces the board
// and the reveal data with no server state, so the in-symbol spin can be
// built and replayed as many times as needed.
// "big_win" at DEV_WIN_MULTIPLIER 65 ends on SUPER MEGA — it clears big (20x),
// mega (40x) and supermega (60x) and stays under max win (10000x), so the whole
// tier chain plays: in → idle(big) → SWITCH → idle(mega) → SWITCH →
// idle(supermega) → out. That is the chain the xBet-on-switch fix needs.
// Inert unless DEV_SIMULATION_ENABLED above is true. Left on "golden_mystery"
// because that is the useful one to come back to: the lid (`my`) opens,
// `myg.reveal` burns its gold sign away, `myg.spin` chases its lights while the
// track turns inside it, and `myg.win` bounces the cell if it pays.
// export const DEV_SIMULATION_MODE = "hp_rows";
// export const DEV_SIMULATION_MODE = "scatter_anticipation";
// export const DEV_SIMULATION_MODE = "coin_anticipation";
// export const DEV_SIMULATION_MODE = "jackpot_coins";
// Big → Mega → Super Mega on a Cleopatra board (DEV_WIN_MULTIPLIER 65).
export const DEV_SIMULATION_MODE = "big_win";

// ── "scatter_anticipation" (Cleopatra's Fire) ──────────────────────────────
// A 5x4 board with scatters on reels 1 and 3, and on reel 5 when HIT. Plain
// pays everywhere else; `wins` is empty and `win` 0, so nothing presents and
// no money is shown that the server did not pay. Client-only: the real spin
// underneath is still what the server recorded.
export const DEV_SCATTER_ANTICIPATION_HIT = true;
const DEV_SC = 10;
export const DEV_SCATTER_ANTICIPATION_ROUND = {
  bet: 20,
  reels: [
    [5, DEV_SC, 6, 1],
    [7, 2, 8, 6],
    [3, 5, DEV_SC, 7],
    [8, 1, 6, 2],
    [DEV_SCATTER_ANTICIPATION_HIT ? DEV_SC : 4, 6, 7, 3],
  ],
  wins: [],
  win: 0,
  winType: null,
  isAnimatedWin: false,
  triggerWin: false,
  id: `test-dev-scatter-anticipation-${Date.now()}`,
};

// ── "coin_anticipation" (Cleopatra's Fire) ─────────────────────────────────
// Coins are code 9 everywhere. No coin values: the API does not send values
// for coins that do not trigger yet, so the coins land blank — that is the
// live look too.
// Total coins on the board: 4, 5 or 6. The ones past 4 land on reel 4.
export const DEV_COIN_ANTICIPATION_COINS = 4;
const DEV_COIN = 9;
const DEV_COIN_EXTRA = Math.max(0, Math.min(2, DEV_COIN_ANTICIPATION_COINS - 4));
export const DEV_COIN_ANTICIPATION_ROUND = {
  bet: 20,
  reels: [
    [DEV_COIN, 5, DEV_COIN, 1],
    // [7, DEV_COIN, 8, DEV_COIN],
    // A high pay on every reel, so each one has a landing clip to watch.
    [7, DEV_COIN, 2, DEV_COIN],
    [3, 5, 2, 7],
    [DEV_COIN_EXTRA >= 1 ? DEV_COIN : 8, 1, DEV_COIN_EXTRA >= 2 ? DEV_COIN : 6, 2],
    [4, 6, 7, 3],
  ],
  wins: [],
  win: 0,
  winType: null,
  isAnimatedWin: false,
  triggerWin: false,
  id: `test-dev-coin-anticipation-${Date.now()}`,
};

// ── "jackpot_coins" (Cleopatra's Fire) ─────────────────────────────────────
// Three jackpot coins (16) on EVERY spin — reel 1 top, reel 3 middle, reel 5
// bottom — each wearing its tier's skin (DEV_JACKPOT_COIN_TIERS), so each
// landing plays its plate's `jackpot_<tier>_hit` on the base game view. Three
// coins: under the anticipation's START_AT (4) and far from a trigger. No win,
// no trigger. Live, a jackpot coin lands in the base game only on a trigger
// board (RGS markJackpotCoins).
export const DEV_JACKPOT_COIN_TIERS = ["mini", "major", "grand"];
const DEV_JACKPOT_COIN = 16;
export const DEV_JACKPOT_COINS_ROUND = {
  bet: 20,
  reels: [
    [DEV_JACKPOT_COIN, 5, 6, 1],
    [7, 2, 8, 6],
    [3, DEV_JACKPOT_COIN, 2, 7],
    [8, 1, 6, 2],
    [4, 6, 7, DEV_JACKPOT_COIN],
  ],
  jackpotCoinSkins: {
    "0_0": `Jp_${DEV_JACKPOT_COIN_TIERS[0]}`,
    "2_1": `Jp_${DEV_JACKPOT_COIN_TIERS[1]}`,
    "4_3": `Jp_${DEV_JACKPOT_COIN_TIERS[2]}`,
  },
  wins: [],
  win: 0,
  winType: null,
  isAnimatedWin: false,
  triggerWin: false,
  id: `test-dev-jackpot-coins-${Date.now()}`,
};

// ── "coin_trails" (Cleopatra's Fire) ───────────────────────────────────────
// Three coins, three different trail paths to the logo. Plain pays elsewhere,
// arranged so no line pays.
export const DEV_COIN_TRAILS_ROUND = {
  bet: 20,
  reels: [
    [DEV_COIN, 5, 6, 1],
    [7, 2, 8, 6],
    [3, DEV_COIN, 2, 7],
    [8, 1, 6, 2],
    [4, 6, 7, DEV_COIN],
  ],
  wins: [],
  win: 0,
  winType: null,
  isAnimatedWin: false,
  triggerWin: false,
  id: `test-dev-coin-trails-${Date.now()}`,
};

// ── "hp_rows" (Cleopatra's Fire) ────────────────────────────────────────────
// Rows 1 and 2 (the middle two) = DEV_HP_ROWS_SYMBOL on every reel; rows 0 and
// 3 = low pays l1–l4 (5–8), mixed. `wins` empty and `win` 0: the line the
// middle rows make is NOT presented.
export const DEV_HP_ROWS_SYMBOL = 1; // 1 h1, 2 h2, 3 h3, 4 h4
export const DEV_HP_ROWS_ROUND = {
  bet: 20,
  reels: [
    [5, DEV_HP_ROWS_SYMBOL, DEV_HP_ROWS_SYMBOL, 7],
    [6, DEV_HP_ROWS_SYMBOL, DEV_HP_ROWS_SYMBOL, 8],
    [7, DEV_HP_ROWS_SYMBOL, DEV_HP_ROWS_SYMBOL, 5],
    [8, DEV_HP_ROWS_SYMBOL, DEV_HP_ROWS_SYMBOL, 6],
    [5, DEV_HP_ROWS_SYMBOL, DEV_HP_ROWS_SYMBOL, 7],
  ],
  wins: [],
  win: 0,
  winType: null,
  isAnimatedWin: false,
  triggerWin: false,
  id: `test-dev-hp-rows-${Date.now()}`,
};

// ── Dev Feature Combo Override ──────────────────────────────────────────────
// Force the bonus buy to request a specific feature combination.
// Sent as `feature_combo` in the API payload alongside purchased_feature.
//
// Set via URL query param:  ?feature=MC  (or M, D, C, MD, DC, MDC)
const _urlCombo =
  typeof window !== "undefined"
    ? new URLSearchParams(window.location.search).get("feature")
    : null;
export const DEV_FEATURE_COMBO = _urlCombo || null;

// ── Win tier ────────────────────────────────────────────────────────────────
// The tier chain comes from win / bet — see computeWinType() and
// getWinSequence(). Every threshold the multiplier clears queues one tier, so
// one big win produces the whole chain instead of jumping to the top.
//
// Thresholds (providerConfig.WIN_THRESHOLDS), as multiples of bet:
//   big_win 20x  ·  mega_win 40x  ·  supermega_win 60x  ·  max_win 10000x
//
// 65x clears the first three and stays under max win:
//   in → idle (big) → SWITCH → idle (mega) → SWITCH → idle (supermega) → out
//
//   25x → big only     45x → big + mega     10000x → all four, ending max win
export const DEV_WIN_MULTIPLIER = 65;

// ── Free spins trigger (round 1415621, captured live 2026-08-13) ────────────
//
// A REAL bought trigger — `purchased_feature: {name: "freespin_buy", level: "1"}`
// on a bet of 50. Fields copied verbatim from the response; only the parts our
// state needs are reshaped.
//
// The board: SC (11) on reels 2 and 3, and the gamble scatter SC1 (12) on
// reel 4 — all on row 0. Exactly the trigger our RGS detection looks for.
const DEV_SCATTER_SCREEN = [
  [7, 7, 7, 7, 3, 3],
  [11, 5, 2, 2, 2, 5],
  [11, 8, 8, 8, 8, 8],
  [12, 7, 1, 1, 1, 7],
  [2, 2, 7, 7, 7, 7],
];

// outcome.special_symbols.scatter — the API states the positions rather than
// leaving us to scan for them. Kept in the same [reel, row] form.
const DEV_SCATTER_POSITIONS = [
  [1, 0], // SC
  [2, 0], // SC
  [3, 0], // SC1, the gamble scatter — the one that spins
];

// ── The reveal payload ──
//
// From `features.fs_gamble` and `outcome.storage.gamble_scatter_values`:
//
//   fs_gamble.values          [[9, 1]]          what was AWARDED
//   fs_gamble.variants        [[0,0],[7,3],…]   what it can be GAMBLED into
//   storage.gamble_scatter_values  [[3,0], 9, 1]  position, value, tier
//
// Each pair is [spinCount, tier]. The tier codes seen so far are
// 0 · 1 · 3 · 5, and they line up with the GDD packages and the three
// `gamble_level_symbol` colour skins:
//
//   0 → blank      no award (GDD "BLANK SC"); the lose slot on the wheel
//   1 → color/low  purple, 4-9 spins, starting Level 0
//   3 → color/mid  red,    7-9 spins, starting Level 2
//   5 → color/high gold,   8-10 spins, starting Level 4
//
// Buying level "1" returned tier 1, which supports that mapping — but it is
// READ FROM ONE ROUND, not documented. Confirm 3 and 5 by buying those tiers
// before relying on it.
//
// `variants` holds no purple entry, only the blank plus every red and gold
// combination. That reads as the gamble ladder of GDD §9: from a Level 0
// award you may gamble up to Level 2 or Level 4, or lose the bonus outright.
// Knobs for building the reveal. Change these to see the other colours —
// the strip, the number and the lit level pips all come from this one pair.
//
//   tier 1 -> color/low   purple, Level 0, values 4-9
//   tier 3 -> color/mid   red,    Level 2, values 7-9
//   tier 5 -> color/high  gold,   Level 4, values 8-10
//   tier 0 -> the BLANK — no award. The full sequence plays and the strip
//             lands on the empty window, exactly what round 1420795 did live
//             (2026-08-18, 2×SC + SC1, server awarded nothing). No feature
//             screen follows: a blank triggers nothing.
//
// Keep the value inside the tier's range or the reveal will show a count the
// math could never award. Tier 0's value is always 0.
//
// The static-texture swap is VERIFIED on both ends (2026-08-18): tier 0 shows
// the empty window, and tier 3 was checked live showing the red card with its
// 9 in the same place the live spine puts it. Change the pair to see another
// colour — 1 purple (4-9), 3 red (7-9), 5 gold (8-10).
export const DEV_GAMBLE_TIER = 5;
export const DEV_GAMBLE_VALUE = 10;

export const DEV_GAMBLE_SCATTER = {
  position: [3, 0],
  value: DEV_GAMBLE_VALUE,
  tier: DEV_GAMBLE_TIER,
  variants: [
    [0, 0],
    [7, 3],
    [8, 3],
    [9, 3],
    [8, 5],
    [9, 5],
    [10, 5],
  ],
};

export const DEV_SCATTER_TRIGGER_ROUND = {
  bet: 50,
  reels: DEV_SCATTER_SCREEN,
  // The synthetic scatter win the RGS adapter injects on a real trigger. The
  // simulation writes state.currentRound directly and so never passes through
  // RGS — it has to be built here by hand, in the same shape.
  wins: [
    {
      id: null,
      win: 0,
      positions: DEV_SCATTER_POSITIONS,
      symbol: null,
      isScatter: true,
    },
  ],
  // The real trigger paid nothing. The free spins pay later.
  win: 0,
  winType: "",
  isAnimatedWin: false,
  // Without this useWinController returns before doing anything at all.
  triggerWin: true,
  // The reveal SHOW plays whatever the strip lands on, so this is true for
  // every tier including the blank — same as RGS sets it from
  // hasRevealSequence. The simulation writes currentRound directly and never
  // passes through the adapter, so it has to be stated here by hand.
  //
  // The AWARD half is not faked: freeSpins.triggered is raised from RGS's
  // freeSpinsTrigger payload, which the simulation does not emit.
  triggerReveal: true,
  // Carried so the reveal can read its own outcome without a server round.
  gambleScatter: DEV_GAMBLE_SCATTER,
  id: `test-dev-scatter-${Date.now()}`,
};

// ── "scatter_blank": the SAME trigger board, landing on nothing ─────────────
//
// Two plain scatters and the gold one, all three landing on the BOARD — no
// mystery, no coins, nothing revealing into them. The gold scatter opens, its
// strip spins, and it stops on the empty window.
//
// It is DEV_SCATTER_TRIGGER_ROUND with one field changed: the outcome. Same
// screen, same positions, same synthetic scatter win, so the only difference a
// test can be measuring is the tier.
//
// `tier: 0` is the blank. GAMBLE_TIERS[0] has no skin, so `toStaticCell`
// returns `awarded: false`, `revealAwarded` is false in both win controllers,
// and `scatter_lose` is what fires instead of `scatter_win`.
//
// `variants` is EMPTY, and that is the half that matters. It is not the strip's
// spin pool — it is what the round can still be GAMBLED into, and a non-empty
// one offers the gamble screen, which awards the package and takes the player
// into free spins. The live blank round (round 1451830, see
// DEV_GOLDEN_BLANK_ROUND) carries `variants: []` for exactly this reason.
//
// So: three scatters land, the gold one spins, it stops on nothing, and the
// round ends. No gamble, no trigger, no free spins.
export const DEV_SCATTER_BLANK_ROUND = {
  ...DEV_SCATTER_TRIGGER_ROUND,
  gambleScatter: {
    position: DEV_GAMBLE_SCATTER.position,
    value: 0,
    tier: 0,
    variants: [],
  },
  id: `test-dev-scatter-blank-${Date.now()}`,
};


// ── Mystery reveal (round 1422843, captured live 2026-08-18) ────────────────
//
// A REAL response — bet 10, fourteen mystery symbols across four reels, all
// revealing into `m1` (index 2), paying 25 lines. Captured inside free
// spins, but the B1 feature is identical in the base game (GDD §3.2: "lands
// anywhere, base game and free spins"), so this drives the base board.
//
// The full capture, with the raw payload, is in docs/dev-simulation-rounds.md.
//
// ── The one thing to understand before changing this ──
//
// `reels` below is the board AFTER the reveal, because that is what the server
// sends: "the screen already arrives with the replaced symbol". Every coord in
// mystery_feature already reads 2 here. Staging the hidden state — drawing
// mystery at those coords FIRST and then revealing into what the screen
// already says — is the client's job, and it is the feature being built.
//
// So do not "fix" the board to show 9s. A round with 9 on the screen is a
// round the server would never send.
// Shared by both simulated rounds' line-symbol resolution. Declared here
// because DEV_MYSTERY_ROUND below is built at module load and reads it.
const WILD_ID = 0;

const DEV_MYSTERY_BET = 10;

const DEV_MYSTERY_SCREEN = [
  [4, 4, 4, 2, 2, 2],
  [2, 2, 2, 2, 2, 2],
  [2, 2, 2, 2, 2, 2],
  [3, 4, 4, 4, 4, 2],
  [2, 2, 2, 2, 2, 2],
];

// outcome.storage.mystery_feature, verbatim. One replacement for the whole
// event — invariant I2, every B1 reveals the SAME symbol.
const DEV_MYSTERY_FEATURE = {
  coords: [
    [1, 0],
    [1, 1],
    [1, 2],
    [1, 3],
    [1, 4],
    [1, 5],
    [2, 0],
    [2, 1],
    [2, 2],
    [2, 3],
    [3, 5],
    [4, 3],
    [4, 4],
    [4, 5],
  ],
  replacement: "2",
};

// outcome.wins — ["line", amount, rowsPerReel, lineId], all 25 of them.
// rowsPerReel[i] is the row the line occupies on reel i, so [5,5,5] becomes
// [[0,5],[1,5],[2,5]] — a three-of-a-kind across the first three reels.
// ── DELIBERATELY A SMALL WIN ──
//
// The capture paid 905 on a bet of 10 — 90.5x, which is a SUPER MEGA and takes
// the whole screen for the tier chain. That hides the thing this round exists
// to show: twenty-five lines cycling over cells the mystery is holding open.
//
// So every line pays 5 here: 125 total, 12.5x, under big_win (20x). The board,
// the coords and the line paths are the capture's own — only the amounts are
// turned down.
const DEV_MYSTERY_WIN_LINES = [
  { lineId: 3, win: 5, rows: [3, 3, 3] },
  { lineId: 4, win: 5, rows: [4, 4, 4] },
  { lineId: 5, win: 5, rows: [5, 5, 5, 5, 5] },
  { lineId: 9, win: 5, rows: [3, 4, 5] },
  { lineId: 10, win: 5, rows: [5, 4, 3] },
  { lineId: 11, win: 5, rows: [4, 3, 2] },
  { lineId: 12, win: 5, rows: [3, 2, 1] },
  { lineId: 17, win: 5, rows: [3, 4, 4] },
  { lineId: 18, win: 5, rows: [4, 5, 5, 5, 4] },
  { lineId: 21, win: 5, rows: [3, 2, 2] },
  { lineId: 22, win: 5, rows: [4, 3, 3] },
  { lineId: 23, win: 5, rows: [5, 4, 4] },
  { lineId: 27, win: 5, rows: [3, 4, 4] },
  { lineId: 28, win: 5, rows: [5, 4, 4] },
  { lineId: 29, win: 5, rows: [4, 3, 3] },
  { lineId: 30, win: 5, rows: [3, 2, 2] },
  { lineId: 35, win: 5, rows: [3, 4, 3] },
  { lineId: 36, win: 5, rows: [4, 5, 4, 5, 4] },
  { lineId: 37, win: 5, rows: [5, 4, 5] },
  { lineId: 38, win: 5, rows: [4, 3, 4] },
  { lineId: 39, win: 5, rows: [3, 2, 3] },
  { lineId: 45, win: 5, rows: [3, 3, 4, 5, 5] },
  { lineId: 46, win: 5, rows: [5, 5, 4] },
  { lineId: 47, win: 5, rows: [4, 4, 3] },
  { lineId: 48, win: 5, rows: [3, 3, 2] },
];

const DEV_MYSTERY_WIN = DEV_MYSTERY_WIN_LINES.reduce((t, l) => t + l.win, 0);

// Same rule the adapter uses: a line's symbol is the first non-wild cell under
// it, falling back to the first cell when the line is all wilds.
const resolveMysteryLineSymbol = (rows) => {
  for (let reel = 0; reel < rows.length; reel++) {
    const symbol = DEV_MYSTERY_SCREEN[reel]?.[rows[reel]];
    if (symbol !== undefined && symbol !== WILD_ID) return symbol;
  }
  return DEV_MYSTERY_SCREEN[0]?.[rows[0]] ?? null;
};

export const DEV_MYSTERY_ROUND = {
  bet: DEV_MYSTERY_BET,
  reels: DEV_MYSTERY_SCREEN,
  wins: DEV_MYSTERY_WIN_LINES.map(({ lineId, win, rows }) => ({
    id: lineId,
    win,
    positions: rows.map((row, reelIndex) => [reelIndex, row]),
    symbol: resolveMysteryLineSymbol(rows),
  })),
  win: DEV_MYSTERY_WIN,
  // 125 on a bet of 10 is 12.5x — under big_win (20x), so NO celebration takes
  // the screen and the line cycle is the only thing running. Left to
  // computeWinType rather than hardcoded, so changing the bet in the UI
  // re-tiers it honestly — the slice rebuilds this round per spin for exactly
  // that reason.
  winType: "",
  isAnimatedWin: false,
  // THE GATE — useWinController returns immediately without it.
  triggerWin: true,
  // Where the mysteries dropped and what they became. This is the field the
  // feature reads; everything above is the board it reveals onto.
  storage: { mystery_feature: DEV_MYSTERY_FEATURE },
  id: `test-dev-mystery-${Date.now()}`,
};

// ── Golden Mystery (B2) ─────────────────────────────────────────────────────
//
// Built from the LIVE fs2 capture documented in
// docs/api-contract-mad-labs-freespins.md §7 — the only Golden Mystery payload
// we have verified end to end.
//
// ── How the feature is entered ──
//
// `replacement: "10"` IS the trigger, and it is the only one. B2 can never land
// directly (invariant I3): a Mystery reveals into it, and every cell that did
// becomes a Golden cell. So the coords below are both the mystery coords and
// the feature's cells — and they have to be: the cells that revealed into B2 are
// exactly the cells that respin.
//
// TEN of them here, on two reels. The capture had five on one, which never
// exercises the stopping cascade.
//
// ── VERIFIED against two live rounds, 2026-08-20 ──
//
// docs/golden-mystery-captures.md has both payloads. What they confirm and this
// round therefore reproduces:
//
//   - iteration 1 lists EVERY mystery cell, so a cell always has an outcome
//   - `screen` already holds "10" at those coords
//   - the payout is `sum(values) x bet` in the base game — (1+2+2+5) x 10 = 100
//     and (1+1) x 10 = 20, both exact
//   - the win is ["coins", payout, coords] with no line id
//   - nothing else is in `storage`
//
// ── Two honest changes from the capture ──
//
// 1. THE LEVEL MULTIPLIER IS GONE. The capture paid 510: sum 17 x bet 10 x the
//    LEVEL-3 multiplier (x3), because it happened inside free spins. There is no
//    level multiplier in the base game, so the payout here is sum x bet.
//    Copying 510 across would have baked a free-spins-only rule into our
//    base-game reference data.
//
// 2. THE VALUES SPAN THE FOUR COIN SKINS, so the whole set of artwork is on
//    screen in one round — see DEV_GOLDEN_COIN_VALUES for the cost of that.
//
// ── What this round CANNOT test ──
//
// A chain. Multipliers (symbol 15) and collectors (symbol 14) respin their own
// cells and can produce more of themselves, which is where the 30,000x cap
// comes from — and no capture we hold contains one, so the encoding of those
// cells inside `coins_feature` is still inference. This round is the verified
// single-step case; the chain gets its own round once the backend confirms the
// shape.
const DEV_GOLDEN_BET = 10;

// ── TWO reels of Golden cells, five each ──
//
// The capture had one reel of five. Ten cells across two reels is the case the
// presentation actually has to survive: every track starts together and they
// stop in board order — reel 0's rows first, then reel 4's — so this is what
// shows whether the cascade reads as a wave or as a mess. See goldenStopOrder.
//
// Reel 0 and reel 4 rather than two neighbours, so the wave crosses the whole
// board and the gap between the groups is obvious.
//
// ── Widened to FIFTEEN, across THREE reels ──
//
// Ten was enough to see the cascade; fifteen is what tests the SKIP. Each tap
// takes the lowest stop order still waiting, and goldenStopOrder sorts by reel
// then row — so with a group at each end AND one in the middle, spamming has
// to walk 0,0 → 0,4, then 2,0 → 2,4, then 4,0 → 4,4. If a press ever brings
// down a cell out of that order, the ordering is wrong and it is visible
// immediately.
const DEV_GOLDEN_COORDS = [
  [0, 0],
  [0, 1],
  [0, 2],
  [0, 3],
  [0, 4],
  [2, 0],
  [2, 1],
  [2, 2],
  [2, 3],
  [2, 4],
  [4, 0],
  [4, 1],
  [4, 2],
  [4, 3],
  [4, 4],
];

// ── One value per SKIN, so all four coin tiers are on screen at once ──
//
// The capture's own values were 1, 1, 5, 5, 5 — all bronze, all one skin, which
// shows a quarter of the artwork. `coinSkinForValue` picks the skin from the
// value (GDD §3.4), so spanning the tiers is just a matter of the numbers:
//
//   1     coin1  bronze
//   10    coin2  silver
//   100   coin3  dark gold
//   1000  coin4  bright gold
//   5000  coin4  bright gold, and the widest value the math can produce —
//                four digits is what tests the fit-to-width rule
//
// ── The total is large BY CONSTRUCTION, and that is not a mistake ──
//
// The tiers are orders of magnitude apart, so any set that spans them sums to
// thousands: 6111 x bet is 6111x, which is a legitimate win under the 30,000x
// cap and will play the whole celebration chain. It plays AFTER the feature
// (GDD §4: reveal, then the Golden Mystery, then wins), so the coins are fully
// on screen before anything covers them.
//
// For a quiet round, drop the last two values: 1, 10, 100 sums to 111 — 11.1x,
// under big_win — and still shows three of the four skins.
const DEV_GOLDEN_COIN_VALUES = [
  // reel 0 — one per skin, low to high
  1, 10, 100, 1000, 5000,
  // reel 2 — a third set, again spanning the skins, so the middle group is
  // told apart from the other two at a glance while the wave crosses it
  1, 5, 50, 500, 2000,
  // reel 4 — the OTHER value in each tier, so the reels are not mirrors
  // and every skin appears from a different number
  2, 25, 250, 2500, 5,
];

// The board AFTER the reveal, which is what the server sends: symbol 10 sits at
// every coord above and the client stages the Mystery back over it.
//
// Reels 0-3 are deliberately four DIFFERENT symbols, one per reel, so the board
// cannot form a paying line of its own. The feature payout is then the only win
// on screen, which is the point of the round.
const DEV_GOLDEN_SCREEN = [
  [10, 10, 10, 10, 10, 5],
  [6, 6, 6, 6, 6, 6],
  [10, 10, 10, 10, 10, 7],
  [8, 8, 8, 8, 8, 8],
  [10, 10, 10, 10, 10, 5],
];

// outcome.storage.mystery_feature — replacement "10" is the handover to B2.
const DEV_GOLDEN_MYSTERY_FEATURE = {
  coords: DEV_GOLDEN_COORDS,
  replacement: "10",
};

// outcome.storage.coins_feature, verbatim in shape: nested one level, each cell
// [[reel,row], symbolId, value], "13" being the coin. The outer array is one
// entry per respin STEP — a single step here, because nothing chained.
const DEV_GOLDEN_COINS_FEATURE = [
  DEV_GOLDEN_COORDS.map((position, i) => [
    position,
    "13",
    DEV_GOLDEN_COIN_VALUES[i],
  ]),
];

const DEV_GOLDEN_WIN =
  DEV_GOLDEN_COIN_VALUES.reduce((t, v) => t + v, 0) * DEV_GOLDEN_BET;

export const DEV_GOLDEN_MYSTERY_ROUND = {
  bet: DEV_GOLDEN_BET,
  reels: DEV_GOLDEN_SCREEN,
  // ── The payout, in the shape the ADAPTER produces ──
  //
  // The API sends `["coins", amount, [[reel,row], ...]]` — no line id, and
  // positions rather than a row-per-reel list. `normalizeWins` now parses it
  // into exactly this: an ordinary win, paid on cells instead of a line.
  //
  // NOT flagged `isCoin`. In this engine that flag means "the line that triggers
  // Pot Collection or Royal Collect" — it suppresses the show-all phase, sorts
  // the entry last, draws no win box and waits for a feature screen to open.
  // None of it applies here. Written the same way in both places so the
  // simulation and the server can never disagree about the shape.
  wins: [
    {
      id: null,
      win: DEV_GOLDEN_WIN,
      positions: DEV_GOLDEN_COORDS,
      symbol: 13,
      // Pay it, do not decorate it — no win box, no per-cell celebration. Same
      // flag the adapter sets, so the two cannot disagree.
      isFeaturePayout: true,
    },
  ],
  win: DEV_GOLDEN_WIN,
  winType: "",
  isAnimatedWin: false,
  // THE GATE — useWinController returns immediately without it.
  triggerWin: true,
  storage: {
    mystery_feature: DEV_GOLDEN_MYSTERY_FEATURE,
    coins_feature: DEV_GOLDEN_COINS_FEATURE,
  },
  id: `test-dev-golden-${Date.now()}`,
};

// ── Golden Mystery, QUIET — the sound round ────────────────────────────────
//
// The same feature as DEV_GOLDEN_MYSTERY_ROUND above, shrunk until the payout
// stays under the big-win threshold. It exists to hear three things that the
// big board drowns:
//
//   golden_mystery_spin   ONE loop for the whole board. It must start with the
//                         first track and stop when the LAST coin lands — the
//                         two groups are at opposite ends so the gap between
//                         them is audible.
//   coin_land             once per landing wave, not once per coin.
//   golden_mystery_win    the feature's own chime, which only plays when the
//                         round did NOT earn a banner.
//
// ── Why the values are these ──
//
// BIG_WIN_THRESHOLD is 20x. The six coins sum to 16, and the payout is
// sum x bet, so the round is 16x — a regular win, every time, at any stake.
// The big board sums to 11,449x and plays the whole celebration chain, which
// silences this chime by design.
//
// Six cells and not one: a single cell would start and stop the loop in one
// breath and prove nothing about the reference count.
const DEV_GOLDEN_QUIET_BET = 10;

// Two groups at opposite ends of the board, three cells each. goldenStopOrder
// sorts by reel then row, so they land 0,0 -> 0,2 and then 4,0 -> 4,2: a wave
// with a clear gap in the middle, which is what makes a loop that stops too
// early obvious rather than arguable.
const DEV_GOLDEN_QUIET_COORDS = [
  [0, 0],
  [0, 1],
  [0, 2],
  [4, 0],
  [4, 1],
  [4, 2],
];

// 1 + 2 + 5 twice = 16. Small on purpose; the skins are not what this round is
// for. See the big board above for one value per skin.
const DEV_GOLDEN_QUIET_COIN_VALUES = [1, 2, 5, 1, 2, 5];

// Reels 1-3 are three DIFFERENT symbols, so the board cannot form a paying
// line of its own and the feature payout is the only win on screen. The filler
// rows under each group are symbol 5, which pays nothing at two of a kind.
const DEV_GOLDEN_QUIET_SCREEN = [
  [10, 10, 10, 5, 5, 5],
  [6, 6, 6, 6, 6, 6],
  [7, 7, 7, 7, 7, 7],
  [8, 8, 8, 8, 8, 8],
  [10, 10, 10, 5, 5, 5],
];

const DEV_GOLDEN_QUIET_WIN =
  DEV_GOLDEN_QUIET_COIN_VALUES.reduce((t, v) => t + v, 0) *
  DEV_GOLDEN_QUIET_BET;

export const DEV_GOLDEN_QUIET_ROUND = {
  bet: DEV_GOLDEN_QUIET_BET,
  reels: DEV_GOLDEN_QUIET_SCREEN,
  wins: [
    {
      id: null,
      win: DEV_GOLDEN_QUIET_WIN,
      positions: DEV_GOLDEN_QUIET_COORDS,
      symbol: 13,
      // The flag goldenWinSound reads. Without it the round plays basic_win.
      isFeaturePayout: true,
    },
  ],
  win: DEV_GOLDEN_QUIET_WIN,
  winType: "",
  isAnimatedWin: false,
  // THE GATE — useWinController returns immediately without it.
  triggerWin: true,
  storage: {
    mystery_feature: {
      coords: DEV_GOLDEN_QUIET_COORDS,
      replacement: "10",
    },
    // One respin STEP, because nothing chains. No multiplier and no collector:
    // this round is about the track and the landing, and a chain would put the
    // upgrade burst and the collect bolts over the top of them.
    coins_feature: [
      DEV_GOLDEN_QUIET_COORDS.map((position, i) => [
        position,
        "13",
        DEV_GOLDEN_QUIET_COIN_VALUES[i],
      ]),
    ],
  },
  id: `test-dev-golden-quiet-${Date.now()}`,
};

// ── Golden Mystery on the FOURTEEN-CELL BOARD ──────────────────────────────
//
// The mystery_reveal board — the capture's own fourteen coords — with the
// replacement swapped from `2` to `10`, so every one of those lids opens onto
// B2 instead of a paying symbol. The biggest golden board a round can produce,
// built to hear the whole feature in one spin rather than to prove anything.
//
// Every golden sound fires here, in order: the lid's build-up, the doors, the
// gold sign burning away, the track (ONE loop, from the first cell to the last
// coin), fourteen landings, the upgrade volley, the collector's arrival and
// its activation, then the feature's own win chime.
//
// ── The anticipation is the SHORT clip here, and that is not a bug ──
//
// The build-up is chosen from POTENTIAL, and mysteryPotential excludes B2 on
// purpose — it pays nothing by itself, it starts a feature. A board whose
// mysteries all become B2 therefore scores 0, which is tier `none`, which is
// `anticipation`. And they must all become B2: invariant I2 says every mystery
// in one event reveals the SAME symbol, so a board cannot hold both B2 and a
// symbol that threatens a line.
//
// Use mode `mystery_reveal` for `anticipation_strong`. The two cannot be the
// same spin.
const DEV_FULL_BET = 10;

// mystery_reveal's coords, unchanged.
const DEV_FULL_COORDS = [
  [1, 0],
  [1, 1],
  [1, 2],
  [1, 3],
  [1, 4],
  [1, 5],
  [2, 0],
  [2, 1],
  [2, 2],
  [2, 3],
  [3, 5],
  [4, 3],
  [4, 4],
  [4, 5],
];

// mystery_reveal's board with `10` written at every coord above — the board
// AFTER the reveal, which is what the server sends.
const DEV_FULL_SCREEN = [
  [4, 4, 4, 2, 2, 2],
  [10, 10, 10, 10, 10, 10],
  [10, 10, 10, 10, 2, 2],
  [3, 4, 4, 4, 4, 10],
  [2, 2, 2, 10, 10, 10],
];

// One of each thing a cell can be, and the rest coins. `15` is the multiplier
// (value = the factor), `14` the collector, `13` a coin.
const DEV_FULL_COINS_FEATURE = [
  [
    [[1, 0], "15", 3],
    [[1, 1], "13", 1],
    [[1, 2], "13", 1],
    [[1, 3], "13", 1],
    [[1, 4], "13", 1],
    [[1, 5], "13", 1],
    [[2, 0], "13", 1],
    [[2, 1], "13", 1],
    [[2, 2], "13", 1],
    [[2, 3], "14"],
    [[3, 5], "13", 1],
    [[4, 3], "13", 1],
    [[4, 4], "13", 1],
    [[4, 5], "13", 1],
  ],
  // The thirteen cells the multiplier and the magnet vacated: the multiplier's
  // own cell plus all twelve coins. The collector stays where it is, holding
  // what it took. Nothing chains from here, so the loop ends.
  [
    [[1, 0], "13", 1],
    [[1, 1], "13", 1],
    [[1, 2], "13", 1],
    [[1, 3], "13", 1],
    [[1, 4], "13", 1],
    [[1, 5], "13", 1],
    [[2, 0], "13", 1],
    [[2, 1], "13", 1],
    [[2, 2], "13", 1],
    [[3, 5], "13", 1],
    [[4, 3], "13", 1],
    [[4, 4], "13", 1],
    [[4, 5], "13", 1],
  ],
];

// GDD §7's order: the multiplier applies to every coin first, then the
// collector takes them.
//
//   iter 1   twelve coins of 1 -> x3 -> twelve 3s = 36, the magnet swallows all
//   iter 2   thirteen cells refill with 1 = 13
//
//   final    collector 36 + coins 13 = 49, times bet 10 = 490
//
// 49x is a MEGA win, so the celebration takes the screen at the end. That is
// after the whole feature has played, so nothing being listened for is covered
// — but it is why this round is not the one to spin back to back. Use
// `golden_quiet` for that.
const DEV_FULL_WIN = 49 * DEV_FULL_BET;

export const DEV_GOLDEN_FULL_ROUND = {
  bet: DEV_FULL_BET,
  reels: DEV_FULL_SCREEN,
  wins: [
    {
      id: null,
      win: DEV_FULL_WIN,
      positions: DEV_FULL_COORDS,
      symbol: 13,
      isFeaturePayout: true,
    },
  ],
  win: DEV_FULL_WIN,
  winType: "",
  isAnimatedWin: false,
  // THE GATE — useWinController returns immediately without it.
  triggerWin: true,
  storage: {
    mystery_feature: { coords: DEV_FULL_COORDS, replacement: "10" },
    coins_feature: DEV_FULL_COINS_FEATURE,
  },
  id: `test-dev-golden-full-${Date.now()}`,
};

// ── "golden_max": EVERY cell on the board — the ceiling ─────────────────────
//
// Not a feature round, a LOAD round. `golden_full` is fourteen cells because
// that is what a real mystery board looked like. This is THIRTY, because the
// question it answers is "what does the Golden Mystery cost when there is
// nothing left to spare", and that is only honest at the maximum.
//
// One iteration and nothing that chains: thirty coins, no multiplier (`15`) and
// no collector (`14`), so no cell is ever vacated and the loop ends where it
// started. Every cell opens, every strip spins, every cell lands — the longest
// possible stretch of simultaneous spinning with the shortest possible tail
// behind it, which is exactly what a frame measurement wants.
//
// The grid is READ from DEV_FULL_SCREEN rather than written out, so "every
// cell" stays true if the board ever changes shape.
const DEV_MAX_BET = 10;
const DEV_MAX_REELS = DEV_FULL_SCREEN.length;
const DEV_MAX_ROWS = DEV_FULL_SCREEN[0].length;

const DEV_MAX_COORDS = [];
for (let reel = 0; reel < DEV_MAX_REELS; reel += 1) {
  for (let row = 0; row < DEV_MAX_ROWS; row += 1) {
    DEV_MAX_COORDS.push([reel, row]);
  }
}

// `10` at every position — the board AFTER the reveal, which is the shape the
// server sends and the one the adapter would have produced.
const DEV_MAX_SCREEN = Array.from({ length: DEV_MAX_REELS }, () =>
  Array.from({ length: DEV_MAX_ROWS }, () => 10),
);

// `13` is a coin worth 1. Thirty of them, and nothing else.
const DEV_MAX_COINS_FEATURE = [DEV_MAX_COORDS.map((coord) => [coord, "13", 1])];

// Thirty coins of 1 -> 30x. That is over the 20x big-win threshold, so a
// celebration plays AFTER the feature has finished. It cannot cover what is
// being measured — the golden spin is long over by then — but it is why this is
// not the round to spin back to back. `golden_quiet` is still the one for that.
const DEV_MAX_WIN = DEV_MAX_COORDS.length * DEV_MAX_BET;

export const DEV_GOLDEN_MAX_ROUND = {
  bet: DEV_MAX_BET,
  reels: DEV_MAX_SCREEN,
  wins: [
    {
      id: null,
      win: DEV_MAX_WIN,
      positions: DEV_MAX_COORDS,
      symbol: 13,
      isFeaturePayout: true,
    },
  ],
  win: DEV_MAX_WIN,
  winType: "",
  isAnimatedWin: false,
  // THE GATE — useWinController returns immediately without it.
  triggerWin: true,
  storage: {
    mystery_feature: { coords: DEV_MAX_COORDS, replacement: "10" },
    coins_feature: DEV_MAX_COINS_FEATURE,
  },
  id: `test-dev-golden-max-${Date.now()}`,
};

// ── Golden Mystery, THE CHAIN (round 1431382, captured live 2026-08-20) ─────
//
// Verbatim. Not adjusted, not scaled, not tidied — this is the only recording we
// have of the multiplier and the collect actually working, and its value is that
// every number in it is the server's.
//
// docs/golden-mystery-captures.md §3b walks through it. In short:
//
//   iteration 1   [3,4] x3 multiplier      [3,5] coin 1
//                 the multiplier fires: every coin x3, so the coin is now 3
//                 the multiplier deletes itself and [3,4] respins
//   iteration 2   [3,4] COLLECT
//                 it sums the coins (3) and is itself worth 3
//                 the coins are removed and [3,5] respins
//   iteration 3   [3,5] coin 5
//                 no multiplier, no collect — the loop ends
//
//   final board   collector 3 + coin 5 = 8   ->   8 x bet 10 = 80
//
// The 80 is what makes it evidence rather than a story: it is only reachable if
// the multiplier applies AND the collector counts the multiplied coin. Without
// the multiplier it is 60; without the collect, 50.
//
// ── THREE things to hold on to while building the loop ──
//
// 1. Iteration 2 and 3 list ONLY the cell that respun. The board must be carried
//    forward and each iteration applied as a PATCH, never as a replacement.
// 2. The collect carries NO value. `[[3,4],"14"]` is two elements — the 3 it is
//    worth exists nowhere in the payload and has to be computed to be drawn.
// 3. The multiplier hit a coin that dropped in its OWN iteration, so an
//    iteration resolves after everything in it has landed, not cell by cell.
const DEV_CHAIN_BET = 10;

// The board, with "10" at the two mystery coords — the server's own screen.
const DEV_CHAIN_SCREEN = [
  [6, 6, 6, 6, 6, 6],
  [1, 1, 6, 6, 6, 6],
  [2, 2, 2, 2, 2, 2],
  [7, 7, 7, 7, 10, 10],
  [8, 8, 7, 7, 7, 7],
];

const DEV_CHAIN_COORDS = [
  [3, 4],
  [3, 5],
];

// outcome.storage.coins_feature, verbatim.
const DEV_CHAIN_COINS_FEATURE = [
  [
    [[3, 4], "15", 3],
    [[3, 5], "13", 1],
  ],
  [[[3, 4], "14"]],
  [[[3, 5], "13", 5]],
];

export const DEV_GOLDEN_CHAIN_ROUND = {
  bet: DEV_CHAIN_BET,
  reels: DEV_CHAIN_SCREEN,
  // ["coins", 80, [[3,4],[3,5]]] as the adapter produces it. The coords are the
  // feature's cells and the payout is final.
  wins: [
    {
      id: null,
      win: 80,
      positions: DEV_CHAIN_COORDS,
      symbol: 13,
      isFeaturePayout: true,
    },
  ],
  win: 80,
  winType: "",
  isAnimatedWin: false,
  triggerWin: true,
  storage: {
    mystery_feature: { coords: DEV_CHAIN_COORDS, replacement: "10" },
    coins_feature: DEV_CHAIN_COINS_FEATURE,
  },
  id: `test-dev-chain-${Date.now()}`,
};

// ── Golden Mystery, WIDE (synthetic, built on the captured shape) ───────────
//
// Round 1431382 proved the loop, but with two cells there is nothing to watch: a
// multiplier that hits one coin and a collector that gathers one coin are both
// invisible as ideas. This is the same shape with five cells, so every part of
// the sequence has something to act on:
//
//   iteration 1   three coins — first reel, middle reel, last reel — and a x2
//                 in the middle of the board
//                 the multiplier doubles all three, then clears its own cell
//   iteration 2   a COLLECT drops into that cell
//                 it gathers all three coins — three bolts — and their cells clear
//   iteration 3   three coins drop back into them
//                 nothing left to resolve, the loop ends
//
//   final board   collector 16 + coins 1+2+5 = 24   ->   24 x bet 10 = 240
//
// ── The layout is the point ──
//
// It was five cells in a column on reel 2, so every bolt fired straight DOWN —
// one direction, and the one that hides a rotation bug. The collector now sits
// in the middle with a coin on the FIRST reel above it, the LAST reel above it,
// and its own reel BELOW it. Three bolts: down-right, down-left, and straight
// up. Every axis on screen in one round.
//
// SYNTHETIC. Every rule it exercises comes from the capture and the BE doc, but
// this exact board never came off a server, so it proves the presentation and
// not the contract. The values are kept small on purpose: 15x is under big_win,
// so nothing takes the screen while the loop is being watched.
const DEV_BIG_BET = 10;

// `10` is the bonus symbol at every feature cell — the reveal's replacement,
// which the screen already carries (see the mystery staging note). The corners
// and the middle: reels 0, 2 and 4.
const DEV_BIG_SCREEN = [
  [10, 6, 6, 6, 6, 6],
  [1, 1, 7, 7, 7, 7],
  [7, 7, 10, 8, 8, 10],
  [7, 7, 8, 8, 8, 8],
  [10, 8, 5, 5, 5, 5],
];

// One cell on the first reel, two on the middle one, one on the last. Every cell
// the feature touches has to be a mystery here, or its reveal never opens.
const DEV_BIG_COORDS = [
  [0, 0],
  [2, 2],
  [2, 5],
  [4, 0],
];

const DEV_BIG_COINS_FEATURE = [
  // 1: three coins — first reel, middle reel, last reel — and the x2 in the
  //    middle of the board
  [
    [[0, 0], "13", 1],
    [[2, 5], "13", 2],
    [[4, 0], "13", 5],
    [[2, 2], "15", 2],
  ],
  // 2: the collect, into the cell the multiplier vacated — the middle of the
  //    board, so its three bolts leave on three different axes
  [[[2, 2], "14"]],
  // 3: the three cleared coin cells refill
  [
    [[0, 0], "13", 1],
    [[2, 5], "13", 2],
    [[4, 0], "13", 5],
  ],
];

export const DEV_GOLDEN_BIG_ROUND = {
  bet: DEV_BIG_BET,
  reels: DEV_BIG_SCREEN,
  wins: [
    {
      id: null,
      win: 240,
      positions: DEV_BIG_COORDS,
      symbol: 13,
      isFeaturePayout: true,
    },
  ],
  win: 240,
  winType: "",
  isAnimatedWin: false,
  triggerWin: true,
  storage: {
    mystery_feature: { coords: DEV_BIG_COORDS, replacement: "10" },
    coins_feature: DEV_BIG_COINS_FEATURE,
  },
  id: `test-dev-golden-big-${Date.now()}`,
};

// ── Golden Mystery, ONE MULTIPLIER, ONE COLUMN (synthetic) ─────────────────
//
// The smallest round that shows the multiplier doing its job and nothing else,
// laid out as a single full reel so every cell is on one axis.
//
// `golden_chain` and `golden_big` both end on a COLLECT, which is a second
// mechanic layered on top — useful once, in the way when the multiplier is what
// is being judged. And both scatter their cells across the board, so the bolts
// leave on different axes and no two are directly comparable. Here all six sit
// one under another on the middle reel: five coins and the x3 between them, so
// every bolt travels the same axis over the same distance and any difference in
// them is the animation's, not the geometry's.
//
//   iteration 1   rows 0,1,3,4,5   coins 1, 1, 2, 1, 1
//                 row 2            x3
//                 the multiplier fires: every coin x3, so 3, 3, 6, 3, 3
//                 the multiplier deletes itself and [2,2] RESPINS
//   iteration 2   [2,2] lands a plain coin 1
//                 no multiplier, no collect — the loop ends
//
//   final board   3 + 3 + 6 + 3 + 3 + 1 = 19   ->   19 x bet 10 = 190
//
// The last 1 is deliberately NOT multiplied. A coin that lands after the
// multiplier has already fired keeps its face value — the capture proves it
// (round 1431382's iteration-3 coin 5 stays a 5), and 190 is only reachable if
// that holds. A board paying 210 means the multiplier is reaching cells that
// dropped after it, which is the fault this round is shaped to expose.
//
// 19x is UNDER big_win (20x), so no celebration takes the screen while the loop
// is being watched. Worth keeping in mind if the coin values are edited.
const DEV_MULT_BET = 10;

// `10` is the bonus symbol at every feature cell — the reveal's replacement,
// which the screen already carries. The WHOLE of reel 2, all six rows.
const DEV_MULT_SCREEN = [
  [6, 6, 6, 6, 6, 6],
  [1, 1, 7, 7, 7, 7],
  [10, 10, 10, 10, 10, 10],
  [7, 7, 8, 8, 8, 8],
  [5, 8, 5, 5, 5, 5],
];

// One column, top to bottom.
const DEV_MULT_COORDS = [
  [2, 0],
  [2, 1],
  [2, 2],
  [2, 3],
  [2, 4],
  [2, 5],
];

// outcome.storage.coins_feature — "13" coin, "15" multiplier. Each entry is one
// ITERATION, and iteration 2 lists ONLY the cell that respun: the board is
// carried forward and each iteration applied as a PATCH, never as a
// replacement. See the note on DEV_CHAIN_COINS_FEATURE.
//
// The x3 sits at row 2 rather than at an end, so it has coins both above and
// below it and its bolts have to travel in both directions.
const DEV_MULT_COINS_FEATURE = [
  [
    [[2, 0], "13", 1],
    [[2, 1], "13", 1],
    [[2, 2], "15", 3],
    [[2, 3], "13", 2],
    [[2, 4], "13", 1],
    [[2, 5], "13", 1],
  ],
  [[[2, 2], "13", 1]],
];

export const DEV_GOLDEN_MULT_ROUND = {
  bet: DEV_MULT_BET,
  reels: DEV_MULT_SCREEN,
  wins: [
    {
      id: null,
      win: 190,
      positions: DEV_MULT_COORDS,
      symbol: 13,
      isFeaturePayout: true,
    },
  ],
  win: 190,
  winType: "",
  isAnimatedWin: false,
  triggerWin: true,
  storage: {
    mystery_feature: { coords: DEV_MULT_COORDS, replacement: "10" },
    coins_feature: DEV_MULT_COINS_FEATURE,
  },
  id: `test-dev-golden-mult-${Date.now()}`,
};

// ── Mystery reveal, the SHORT build-up ─────────────────────────────────────
//
// The same feature as `mystery_reveal`, deliberately SMALL. The anticipation
// clip is not a setting — mysteryDrama picks it from what the board THREATENS:
//
//   potential >= big_win (20x bet)  ->  `anticipation_strong`  2000ms
//   anything less                   ->  `anticipation`          500ms
//
// So the fourteen-cell round can only ever take the long one, and the short one
// needs a board that threatens little. Two cells on reel 1, with reels 2-4
// holding three DIFFERENT symbols so nothing past reel 1 can complete — the
// best the mysteries can make is a three-of-a-kind on the low that already sits
// on reel 0, which is a handful of x bet.
//
// Built to watch the 500ms build-up and the scene's lamp fitted to it: one pass
// at 1.60x, against two at 0.80x on the long one. See SCENE_ACCENTS.MYSTERY_WAIT.
const DEV_SHORT_BET = 10;

// `4` is a low pay. Reels 2, 3 and 4 are three different symbols on purpose:
// the reveal cannot reach past reel 1, so the potential stays small.
const DEV_SHORT_SCREEN = [
  [4, 4, 4, 6, 6, 6],
  [4, 4, 7, 7, 7, 7],
  [5, 5, 5, 5, 5, 5],
  [6, 6, 6, 6, 6, 6],
  [7, 7, 7, 7, 7, 7],
];

// Two cells, both on reel 1 — the board already reads `4` there, which is what
// the server sends: the screen arrives AFTER the reveal.
const DEV_SHORT_COORDS = [
  [1, 0],
  [1, 1],
];

const DEV_SHORT_FEATURE = {
  coords: DEV_SHORT_COORDS,
  replacement: "4",
};

// Three `4`s across reels 0-1 on the top two rows. The amount is nominal — what
// is being watched is the build-up, not the payout — and small on purpose so no
// celebration takes the screen afterwards.
const DEV_SHORT_WIN = 2 * DEV_SHORT_BET;

export const DEV_MYSTERY_SHORT_ROUND = {
  bet: DEV_SHORT_BET,
  reels: DEV_SHORT_SCREEN,
  wins: [
    {
      id: null,
      win: DEV_SHORT_WIN,
      positions: [
        [0, 0],
        [1, 0],
      ],
      symbol: 4,
    },
  ],
  win: DEV_SHORT_WIN,
  winType: "",
  isAnimatedWin: false,
  triggerWin: true,
  storage: {
    mystery_feature: DEV_SHORT_FEATURE,
  },
  id: `test-dev-mystery-short-${Date.now()}`,
};

// ── Golden Mystery: EVERY symbol type on the board at once ──────────────────
//
// SYNTHETIC, and for looking at rather than proving anything. Eight cells across
// reels 0 and 4, so the stop wave crosses the whole board, and one of each thing
// a cell can land on:
//
//   [0,0] x3 multiplier    [4,0] coin
//   [0,1] coin             [4,1] coin
//   [0,2] coin             [4,2] COLLECTOR
//   [0,3] SC               [4,3] SC1, awarding nothing
//
// So every landing clip is on screen in one spin — `mul`, `c`, `cl`, `sc` and
// `scg` — and then the loop runs both phases over them.
//
// ── SC1 lands but triggers nothing, on purpose ──
//
// `fs_count` is 0, which the BE doc says is a real outcome — the scatter can
// award nothing and re-roll. goldenGambleCell requires a count above zero, so
// the cell is a picture here and the free-spins trigger stays out of the way.
//
// ── The arithmetic, which the script checks ──
//
// GDD §7's loop, in order: the multiplier applies to ALL coins first, then the
// collector takes them.
//
//   iter 1   coins 1,1,1,1 -> x3 -> 3,3,3,3, the magnet swallows all 12
//            the multiplier and the four coin cells are all vacated
//   iter 2   those five cells refill: 1,1,1,1,2
//
// Final board: the magnet holding 12 plus 6 in coins = 18, times bet 10 = 180.
// The scatters carry no value and are not in the sum.
//
// Values kept at 1 deliberately: 18x bet is under big_win (20x), so nothing
// takes the screen afterwards and the feature can be watched back to back.
const DEV_ALL_BET = 10;

const DEV_ALL_SCREEN = [
  [10, 10, 10, 10, 5, 5],
  [6, 6, 6, 6, 6, 6],
  [7, 7, 7, 7, 7, 7],
  [8, 8, 8, 8, 8, 8],
  [10, 10, 10, 10, 5, 5],
];

const DEV_ALL_COORDS = [
  [0, 0],
  [0, 1],
  [0, 2],
  [0, 3],
  [4, 0],
  [4, 1],
  [4, 2],
  [4, 3],
];

const DEV_ALL_COINS_FEATURE = [
  [
    [[0, 0], "15", 3],
    [[0, 1], "13", 1],
    [[0, 2], "13", 1],
    [[0, 3], "11"],
    [[4, 0], "13", 1],
    [[4, 1], "13", 1],
    [[4, 2], "14"],
    [[4, 3], "12", 0],
  ],
  // The five cells the multiplier and the magnet vacated.
  [
    [[0, 0], "13", 1],
    [[0, 1], "13", 1],
    [[0, 2], "13", 1],
    [[4, 0], "13", 1],
    [[4, 1], "13", 2],
  ],
];

const DEV_ALL_WIN = 18 * DEV_ALL_BET;

export const DEV_GOLDEN_ALL_ROUND = {
  bet: DEV_ALL_BET,
  reels: DEV_ALL_SCREEN,
  wins: [
    {
      id: null,
      win: DEV_ALL_WIN,
      positions: DEV_ALL_COORDS,
      symbol: 13,
      isFeaturePayout: true,
    },
  ],
  win: DEV_ALL_WIN,
  winType: "",
  isAnimatedWin: false,
  triggerWin: true,
  storage: {
    mystery_feature: { coords: DEV_ALL_COORDS, replacement: "10" },
    coins_feature: DEV_ALL_COINS_FEATURE,
  },
  id: `test-dev-golden-all-${Date.now()}`,
};

// ── Golden Mystery landing the GAMBLE SCATTER ───────────────────────────────
//
// ROUND A (see docs/golden-mystery-captures.md §2) with ONE cell changed.
//
// The board, the coords and the coin values are the server's own — four
// mysteries STACKED on reel 4, revealing into B2, paying `sum x bet`. That
// stack is what a real B2 round looks like: both captures landed on a single
// reel, not spread across the board.
//
// The one change is the last cell. It paid a coin worth 5; here it lands the
// GAMBLE SCATTER instead, `[coord, "12", fs_count, fs_level]`. Reel 4 is also
// the only reel SC1 may land on (GDD I9), so the cell is in a place the symbol
// can really be. The numbers obey GDD §9: tier 1 is Level 0, band 4-9 spins.
//
// So the payout drops from (1+2+2+5) x 10 = 100 to (1+2+2) x 10 = 50 — the
// scatter carries no coin value and is not in the win.
//
// ── What this round CANNOT show, and why it is left out ──
//
// The live path also appends a synthetic scatter win, which is what schedules
// the gamble screen. It is NOT here. `freeSpins.triggered` is raised from RGS's
// `freeSpinsTrigger` payload and the simulation writes state.currentRound
// directly without passing through the adapter, so the screen can never open —
// and a trigger line that opens nothing leaves the win cycle running forever,
// alternating a real payout with a 0-win line. That is the flashing.
//
// Faking the award instead is not an option: the gamble screen's PLAY and SKIP
// send commands to a server that never offered them, and two of those bans the
// player.
//
// So this round shows the FEATURE — the stack revealing, the cells spinning,
// the scatter landing and the coins paying. The trigger half is covered by
// src/Games/Shared/__tests__/goldenMysteryStaging.gamble.test.js.
const DEV_GAMBLE_CELL_BET = 10;

// Round A's board: four mysteries on reel 4, rows 2-5. `10` is the bonus
// symbol, which the screen already carries — the server sends the board with
// the replacement in place and the client stages the mystery back over it.
const DEV_GAMBLE_CELL_SCREEN = [
  [6, 6, 1, 1, 7, 7],
  [7, 7, 8, 8, 5, 5],
  [1, 1, 7, 7, 8, 8],
  [8, 8, 5, 5, 6, 6],
  [7, 6, 10, 10, 10, 10],
];

const DEV_GAMBLE_CELL_COORDS = [
  [4, 2],
  [4, 3],
  [4, 4],
  [4, 5],
];

const DEV_GAMBLE_CELL_COINS_FEATURE = [
  [
    [[4, 2], "13", 1],
    [[4, 3], "13", 2],
    [[4, 4], "13", 2],
    [[4, 5], "12", 8, 1],
  ],
];

// Coins only. The scatter carries no coin value, so it is not in the sum and
// not in the win's coords either.
const DEV_GAMBLE_CELL_COIN_COORDS = [
  [4, 2],
  [4, 3],
  [4, 4],
];
const DEV_GAMBLE_CELL_WIN = (1 + 2 + 2) * DEV_GAMBLE_CELL_BET;

export const DEV_GOLDEN_GAMBLE_ROUND = {
  bet: DEV_GAMBLE_CELL_BET,
  reels: DEV_GAMBLE_CELL_SCREEN,
  wins: [
    {
      id: null,
      win: DEV_GAMBLE_CELL_WIN,
      positions: DEV_GAMBLE_CELL_COIN_COORDS,
      symbol: 13,
      isFeaturePayout: true,
    },
  ],
  win: DEV_GAMBLE_CELL_WIN,
  winType: "",
  isAnimatedWin: false,
  triggerWin: true,
  // FALSE, and this is the difference from DEV_SCATTER_TRIGGER_ROUND. The
  // doors-and-strip reveal belongs to SC1 on the board (GDD §8). This cell ran
  // its own landing sequence inside the feature, so there is nothing to hold
  // the board for.
  triggerReveal: false,
  storage: {
    mystery_feature: { coords: DEV_GAMBLE_CELL_COORDS, replacement: "10" },
    coins_feature: DEV_GAMBLE_CELL_COINS_FEATURE,
  },
  id: `test-dev-golden-gamble-${Date.now()}`,
};

// ── TWO gamble scatters out of one Golden Mystery ───────────────────────────
//
// The same board as the round above, with a SECOND cell landing symbol 12.
// Seen on the reference game in the base game, 2026-09-18: the mystery strip
// carries coins, multipliers, the magnet and the scatter, and two of its cells
// stopped on the scatter. Each one then opened its own doors and spun its own
// strip, while the rest of the feature carried on around them.
//
// What this round is FOR is the gap: our reveal is claimed once per round —
// `revealPlayedForRoundRef` in useWinController — and `goldenGambleRevealCell`
// answers with a single cell, so the second scatter has nothing to open it.
// Run this and watch [4,5] while [4,3] performs.
//
// The two packages are deliberately different (tier 1 / 8 spins and tier 5 /
// 10 spins) so the two windows cannot be confused for one another once both
// do open.
//
// Award half NOT faked, for the same reason as the round above: the gamble
// screen would send commands the server never offered, and two of those bans
// the player.
const DEV_GAMBLE_TWO_COINS_FEATURE = [
  [
    [[4, 2], "13", 1],
    [[4, 3], "12", 8, 1],
    [[4, 4], "13", 2],
    [[4, 5], "12", 10, 5],
  ],
];

// Coins only — neither scatter carries a coin value, so neither is in the sum.
const DEV_GAMBLE_TWO_COIN_COORDS = [
  [4, 2],
  [4, 4],
];
const DEV_GAMBLE_TWO_WIN = (1 + 2) * DEV_GAMBLE_CELL_BET;

export const DEV_GOLDEN_GAMBLE_TWO_ROUND = {
  bet: DEV_GAMBLE_CELL_BET,
  reels: DEV_GAMBLE_CELL_SCREEN,
  wins: [
    {
      id: null,
      win: DEV_GAMBLE_TWO_WIN,
      positions: DEV_GAMBLE_TWO_COIN_COORDS,
      symbol: 13,
      isFeaturePayout: true,
    },
  ],
  win: DEV_GAMBLE_TWO_WIN,
  winType: "",
  isAnimatedWin: false,
  triggerWin: true,
  triggerReveal: false,
  storage: {
    mystery_feature: { coords: DEV_GAMBLE_CELL_COORDS, replacement: "10" },
    coins_feature: DEV_GAMBLE_TWO_COINS_FEATURE,
  },
  id: `test-dev-golden-gamble-two-${Date.now()}`,
};

// ── The combination Vladimir hit live, round 1451830 (2026-09-04) ───────────
//
// THE CASE NOBODY EXPECTED, and the reason this round exists: three scatters
// reached without SC1 ever landing on the reels.
//
//   1. a plain SC (11) lands on the BOARD, on reel 2 — legal per I9
//   2. the Golden Mystery drops a SECOND SC (11) on one of its cells
//   3. the Golden Mystery drops SC1 (12) on another — and it is BLANK
//
// Three scatters, so §8's condition is met. The blank is the point: GDD §3.3
// lists BLANK as one of SC1's four outcomes and §8 says it "reveals its
// outcome and, UNLESS BLANK, hands off to the Gamble Round". So the doors open,
// the strip spins, it lands on the empty window, and nothing is awarded.
//
// ── Why this one can be simulated end to end, unlike `golden_gamble` ──
//
// That round is the AWARDED case, and its award half cannot be faked: the
// trigger comes from RGS's `freeSpinsTrigger` payload, which the simulation
// never produces. A blank awards nothing, so there is nothing to fake — the
// whole round IS the show. It is therefore the one gamble-scatter case a
// simulation can prove.
//
// It also proves 16.12 the other way: the plain SC the feature dropped is NOT
// the dead outcome that question assumed. It is the second scatter, and without
// it the third could not be there at all.
const DEV_BLANK_BET = 10;

// Reel 2 carries the board's SC at row 0. Reel 4 is the mystery stack, rows
// 0-3, which the screen already shows as B2 ("10") — the server sends the board
// after the reveal. Reel 4 is also the only reel SC1 may occupy (I9), which is
// why the feature's scatter is placed there.
const DEV_BLANK_SCREEN = [
  ["6", "6", "6", "6", "6", "6"],
  ["7", "7", "7", "7", "7", "7"],
  ["11", "8", "8", "8", "8", "8"],
  ["5", "5", "5", "5", "5", "5"],
  ["10", "10", "10", "10", "1", "1"],
];

const DEV_BLANK_COORDS = [
  [4, 0],
  [4, 1],
  [4, 2],
  [4, 3],
];

// One iteration, nothing chains. Two coins, the feature's own SC, and the blank
// gamble scatter: `[coord, "12", fsCount, fsLevel]` with a count of ZERO, which
// is what makes it a blank. goldenGambleCell rejects it (no award);
// goldenGambleRevealCell finds it (the show still runs).
const DEV_BLANK_COINS_FEATURE = [
  [
    [[4, 0], "13", 2],
    [[4, 1], "13", 5],
    [[4, 2], "11"],
    [[4, 3], "12", 0, 0],
  ],
];

// Coins only — neither scatter carries a coin value, so neither is in the sum
// or in the win's coords. (2 + 5) x 10 = 70, which is 7x bet: under big_win, so
// no celebration takes the screen while the reveal is being watched.
const DEV_BLANK_COIN_COORDS = [
  [4, 0],
  [4, 1],
];
const DEV_BLANK_WIN = (2 + 5) * DEV_BLANK_BET;

// All three scatters, in trigger order — the board's, the feature's plain one,
// and SC1 last. This is what the win cycle walks to animate them once the coins
// have finished, and it is shared by the awarding round and the blank one so
// the two differ only by the package.
const DEV_AWARD_TRIGGER_COORDS = [
  [2, 0],
  [4, 2],
  [4, 3],
];

export const DEV_GOLDEN_BLANK_ROUND = {
  bet: DEV_BLANK_BET,
  reels: DEV_BLANK_SCREEN,
  wins: [
    {
      id: null,
      win: DEV_BLANK_WIN,
      positions: DEV_BLANK_COIN_COORDS,
      symbol: 13,
      isFeaturePayout: true,
    },
    // ── The synthetic scatter win, because the LIVE game builds one ──
    //
    // `collectAllTriggerPositions` appends this whenever the trigger BOARD is
    // complete — three scatters — and a blank is still a complete board. So a
    // real blank round carries this entry, and a simulation without it tests a
    // shape the server cannot send.
    //
    // It is not a win and must never be presented as one: the client decides
    // that from the round's own package (`gambleScatter` value 0, tier 0) and
    // skips both its show-all cells and its turn in the cycle. That is the
    // behaviour this round exists to exercise.
    //
    // It also carries the reveal position, which is what opens the doors for a
    // scatter that landed on the BOARD. A feature-dropped one is opened by the
    // Golden Mystery block instead, from `goldenGambleRevealCell`.
    {
      id: null,
      win: 0,
      positions: DEV_AWARD_TRIGGER_COORDS,
      symbol: null,
      isScatter: true,
    },
  ],
  win: DEV_BLANK_WIN,
  winType: "",
  isAnimatedWin: false,
  triggerWin: true,
  // TRUE, and this is the whole difference from `golden_gamble`. The reveal is
  // owed to SC1 wherever it came from — see the RGS note that used to say the
  // opposite.
  triggerReveal: true,
  // What the strip must settle on: tier 0, the empty window. `variants` is
  // empty because a blank offers no ladder to gamble into.
  gambleScatter: {
    position: [4, 3],
    value: 0,
    tier: 0,
    variants: [],
  },
  storage: {
    mystery_feature: { coords: DEV_BLANK_COORDS, replacement: "10" },
    coins_feature: DEV_BLANK_COINS_FEATURE,
  },
  id: `test-dev-golden-blank-${Date.now()}`,
};

// ── The same round, but the gamble scatter AWARDS ────────────────────────────
//
// Round 1451830 with two numbers changed: `[[4, 3], "12", 8, 3]` instead of
// `0, 0`. Everything else is identical, which is the point — it isolates the
// one thing under test.
//
// The three scatters are the board's SC at [2, 0], the feature's SC at [4, 2]
// and the feature's SC1 at [4, 3]. That is a complete trigger under GDD §8 and
// it is SPLIT across the board and the feature, which is the case the RGS could
// not count until collectAllTriggerPositions existed.
//
// The order matters and matches what the RGS builds: plain scatters first,
// SC1 LAST. buildGambleScatterReveal reads the last entry as SC1's position.
const DEV_AWARD_COINS_FEATURE = [
  [
    [[4, 0], "13", 2],
    [[4, 1], "13", 5],
    [[4, 2], "11"],
    [[4, 3], "12", 8, 3],
  ],
];

export const DEV_GOLDEN_AWARD_ROUND = {
  bet: DEV_BLANK_BET,
  reels: DEV_BLANK_SCREEN,
  wins: [
    // The coins pay first and alone — the feature's own payout, undecorated.
    {
      id: null,
      win: DEV_BLANK_WIN,
      positions: DEV_BLANK_COIN_COORDS,
      symbol: 13,
      isFeaturePayout: true,
    },
    // Then the trigger. orderLineIds sorts this LAST whatever order it is
    // written in, so the coins' glow is gone before the scatters light.
    {
      id: null,
      win: 0,
      positions: DEV_AWARD_TRIGGER_COORDS,
      symbol: null,
      isScatter: true,
    },
  ],
  win: DEV_BLANK_WIN,
  winType: "",
  isAnimatedWin: false,
  triggerWin: true,
  triggerReveal: true,
  // 8 spins at level 3 — a real package, so the strip lands on it and hands off
  // to the Gamble Round. `variants` is the ladder still on offer; two rungs so
  // the gamble screen has something to show.
  gambleScatter: {
    position: [4, 3],
    value: 8,
    tier: 3,
    variants: [
      [12, 4],
      [16, 5],
    ],
  },
  storage: {
    mystery_feature: { coords: DEV_BLANK_COORDS, replacement: "10" },
    coins_feature: DEV_AWARD_COINS_FEATURE,
  },
  id: `test-dev-golden-award-${Date.now()}`,
};

// ── WIN + BONUS TRIGGER, the combination that keeps breaking ────────────────
//
// SYNTHETIC, and deliberately the SIMPLEST possible version of it: ordinary
// line wins on the board AND three scatters, with no Golden Mystery anywhere
// near it. Every other round that reaches this shape drags a feature in with
// it — `golden_award` pays through the coins feature, `golden_blank` lands its
// scatters inside B2 — so a fault could always be the feature's. Here it
// cannot be. Lines pay, scatters trigger, nothing else happens.
//
// ── The board ──
//
//   reel 0   m3 m3 m3            rows 0-2
//   reel 1   SC m3 m3            SC at row 0
//   reel 2   SC m3 m3            SC at row 0
//   reel 3   SC1 ...             the gamble scatter, row 0
//   reel 4   —
//
// Two straight lines of m3 across reels 0-2, on rows 1 and 2. Row 0 is NOT a
// line: reel 1 holds a scatter there, so the win and the trigger occupy
// different cells and neither can be mistaken for the other.
//
// SC1 sits on reel index 3, which is where round 1415621 put it live. The
// index-4 claim in `golden_blank` is the same rule counted from one instead of
// zero; the captured round is the authority.
//
// ── The order the wins are written in ──
//
// Lines first, the scatter entry LAST. `orderLineIds` enforces that anyway,
// but writing it the other way round would hide a regression in the sorter,
// which is exactly the kind of thing this round exists to catch.
//
// ── The knob that matters ──
//
// DEV_WIN_TRIGGER_MULTIPLIER decides whether the win is a plain one or a
// celebration, and the two take DIFFERENT PATHS through useWinController:
//
//   8   (default)  under big_win (20x) — `isAnimatedWin` false, so the show-all
//                  runs, basic_win plays, and the reveal is reached from the
//                  ordinary line cycle. This is the reported case.
//   65             over supermega (60x) — the tier chain takes the screen
//                  first and the trigger has to survive behind it.
//
// Both are "win + bonus trigger". Test the 8 first; it is the one that was
// sitting on a dimmed board.
// ── ROUND 1472920 VERBATIM — three magnets, a x2, and a scatter re-rolling ──
//
// Captured live 2026-09-22 and the most complicated round this feature has
// produced. Four full reels of Golden cells, and in five iterations:
//
//   three MAGNETS, each swallowing the one before it   [4,2] [3,2] [4,3]
//   one x2 MULTIPLIER, on the fourth pass              [3,0]
//   a plain SCATTER dropped by the feature             [0,5]
//   a BLANK gamble scatter, re-listed EVERY iteration  [2,3]
//
// It is the round three separate faults were found on, and the one to come
// back to for all of them:
//
//   1. The blank SC1 re-rolls four times — once per iteration after its
//      landing — each turn matching the coins' flow exactly.
//   2. Its board carries the full scatter line (the board's own SC at [1,1],
//      the feature's SC at [0,5], the SC1 at [2,3]), which is what used to
//      send the whole round through initGame's lost-gamble strip and throw
//      the 9510 away on reload.
//   3. THREE magnets, which is what proved a swallowed magnet keeps its
//      total — see the note in goldenMysteryScript. 951 x bet, exactly.
//
// Every number below is the server's own. `verifyGoldenScript` must report
// `ok=true expected=9510 actual=9510` on it; anything else is a change to the
// loop's rules, and this round is the evidence they are wrong.
const DEV_REROLL_BET = 10;

// outcome.screen, verbatim. Reel 1 is the only untouched one: an l4 and the
// board's own scatter over four m1s.
const DEV_REROLL_SCREEN = [
  [10, 10, 10, 10, 10, 10],
  [8, 11, 1, 1, 1, 1],
  [10, 10, 10, 10, 10, 10],
  [10, 10, 10, 10, 10, 10],
  [10, 10, 10, 10, 10, 10],
];

// storage.mystery_feature.coords — every cell of reels 0, 2, 3 and 4.
const DEV_REROLL_COORDS = [0, 2, 3, 4].flatMap((reel) =>
  [0, 1, 2, 3, 4, 5].map((row) => [reel, row]),
);

// outcome.storage.coins_feature, verbatim: "13" coin, "14" magnet,
// "15" multiplier, "11" scatter, "12" gamble scatter (blank at 0, 0).
const DEV_REROLL_COINS_FEATURE = [
  [
    [[0, 0], "13", 1], [[0, 1], "13", 1], [[0, 2], "13", 5],
    [[0, 3], "13", 2], [[0, 4], "13", 2], [[0, 5], "11"],
    [[2, 0], "13", 1], [[2, 1], "13", 2], [[2, 2], "13", 1],
    [[2, 3], "12", 0, 0], [[2, 4], "13", 1], [[2, 5], "13", 1],
    [[3, 0], "13", 2], [[3, 1], "13", 1], [[3, 2], "13", 1],
    [[3, 3], "13", 2], [[3, 4], "13", 2], [[3, 5], "13", 1],
    [[4, 0], "13", 1], [[4, 1], "13", 1], [[4, 2], "14"],
    [[4, 3], "13", 2], [[4, 4], "13", 5], [[4, 5], "13", 1],
  ],
  [
    [[0, 0], "13", 5], [[0, 1], "13", 2], [[0, 2], "13", 25],
    [[0, 3], "13", 5], [[0, 4], "13", 2],
    [[2, 0], "13", 10], [[2, 1], "13", 2], [[2, 2], "13", 2],
    [[2, 3], "12", 0, 0], [[2, 4], "13", 2], [[2, 5], "13", 2],
    [[3, 0], "13", 1], [[3, 1], "13", 1], [[3, 2], "14"],
    [[3, 3], "13", 2], [[3, 4], "13", 2], [[3, 5], "13", 1],
    [[4, 0], "13", 1], [[4, 1], "13", 10], [[4, 3], "13", 2],
    [[4, 4], "13", 1], [[4, 5], "13", 5],
  ],
  [
    [[0, 0], "13", 5], [[0, 1], "13", 10], [[0, 2], "13", 1],
    [[0, 3], "13", 1], [[0, 4], "13", 1],
    [[2, 0], "13", 1], [[2, 1], "13", 2], [[2, 2], "13", 1],
    [[2, 3], "12", 0, 0], [[2, 4], "13", 2], [[2, 5], "13", 1],
    [[3, 0], "13", 1], [[3, 1], "13", 2], [[3, 3], "13", 1],
    [[3, 4], "13", 1], [[3, 5], "13", 2],
    [[4, 0], "13", 1], [[4, 1], "13", 2], [[4, 3], "14"],
    [[4, 4], "13", 25], [[4, 5], "13", 1],
  ],
  [
    [[0, 0], "13", 2], [[0, 1], "13", 2], [[0, 2], "13", 1],
    [[0, 3], "13", 2], [[0, 4], "13", 1],
    [[2, 0], "13", 1], [[2, 1], "13", 5], [[2, 2], "13", 10],
    [[2, 3], "12", 0, 0], [[2, 4], "13", 10], [[2, 5], "13", 5],
    [[3, 0], "15", 2], [[3, 1], "13", 2], [[3, 3], "13", 1],
    [[3, 4], "13", 2], [[3, 5], "13", 2],
    [[4, 0], "13", 2], [[4, 1], "13", 50], [[4, 4], "13", 5],
    [[4, 5], "13", 1],
  ],
  [[[2, 3], "12", 0, 0], [[3, 0], "13", 1]],
];

// `wins[0][2]`, verbatim: the 22 cells the server paid on. The scatter at
// [0,5] and the gamble scatter at [2,3] are NOT among them — they pay nothing.
const DEV_REROLL_COIN_COORDS = [
  [0, 0], [0, 1], [0, 2], [0, 3], [0, 4],
  [2, 0], [2, 1], [2, 2], [2, 4], [2, 5],
  [3, 0], [3, 1], [3, 2], [3, 3], [3, 4], [3, 5],
  [4, 0], [4, 1], [4, 2], [4, 3], [4, 4], [4, 5],
];

// 951 x bet — `["coins", 9510, [...]]` at bet 10.
const DEV_REROLL_WIN = 951 * DEV_REROLL_BET;

// The three scatters, in the order the RGS builds them: plain ones first, SC1
// LAST, because buildGambleScatterReveal reads the last entry as SC1.
const DEV_REROLL_TRIGGER_COORDS = [
  [1, 1],
  [0, 5],
  [2, 3],
];

export const DEV_GOLDEN_REROLL_ROUND = {
  bet: DEV_REROLL_BET,
  reels: DEV_REROLL_SCREEN,
  wins: [
    {
      id: null,
      win: DEV_REROLL_WIN,
      positions: DEV_REROLL_COIN_COORDS,
      symbol: 13,
      isFeaturePayout: true,
    },
    // Pays nothing and carries positions. Its presence is the point: it is
    // what makes a reload run this round through initGame's strip.
    {
      id: null,
      win: 0,
      positions: DEV_REROLL_TRIGGER_COORDS,
      symbol: null,
      isScatter: true,
    },
  ],
  win: DEV_REROLL_WIN,
  winType: "supermega_win",
  isAnimatedWin: true,
  triggerWin: true,
  triggerReveal: true,
  // Blank, five times over. `variants` is empty — a blank offers no ladder.
  gambleScatter: {
    position: [2, 3],
    value: 0,
    tier: 0,
    variants: [],
  },
  storage: {
    mystery_feature: { coords: DEV_REROLL_COORDS, replacement: "10" },
    gamble_scatter_values: [[2, 3], 0, 0],
    coins_feature: DEV_REROLL_COINS_FEATURE,
  },
  id: `test-dev-golden-reroll-${Date.now()}`,
};

// ── The SAME round, but the scatter AWARDS on its last turn ─────────────────
//
// Round 1472920 with two numbers changed in the final iteration:
// `[[2,3], "12", 8, 3]` instead of `0, 0`. Everything before it stays blank, so
// the window still re-rolls four times — and on the fourth it lands a real
// package instead of the empty gold frame.
//
// This is the combination Vladimir asked for, 2026-09-22: *"we can have win +
// free spins win... we would process wins and then move to scatters and enter
// bonus game or gamble."* One round carrying BOTH, and in this order:
//
//   the feature runs           coins, three magnets, the x2
//   the scatter re-rolls       blank, blank, blank...
//   ...and then AWARDS         8 spins at level 3, on the last iteration
//   the win presents           9510, the whole line cycle
//   the trigger hands off      the three scatters light, then the gamble screen
//
// It is also the one round where the per-iteration package matters: read the
// ROUND's `gambleScatter` at the first landing and the player is shown 8 spins
// before they have won them, with three pointless re-rolls after it. Each
// window lands on its own cell — see cellPackage in useWinController.
const DEV_REROLL_AWARD_COINS_FEATURE = [
  ...DEV_REROLL_COINS_FEATURE.slice(0, 4),
  [[[2, 3], "12", 8, 3], [[3, 0], "13", 1]],
];

export const DEV_GOLDEN_REROLL_AWARD_ROUND = {
  bet: DEV_REROLL_BET,
  reels: DEV_REROLL_SCREEN,
  wins: [
    {
      id: null,
      win: DEV_REROLL_WIN,
      positions: DEV_REROLL_COIN_COORDS,
      symbol: 13,
      isFeaturePayout: true,
    },
    {
      id: null,
      win: 0,
      positions: DEV_REROLL_TRIGGER_COORDS,
      symbol: null,
      isScatter: true,
    },
  ],
  win: DEV_REROLL_WIN,
  winType: "supermega_win",
  isAnimatedWin: true,
  triggerWin: true,
  triggerReveal: true,
  // The package the LAST turn lands on, and what the gamble screen is handed.
  // `variants` is the ladder still on offer — two rungs, so that screen has
  // something to show.
  gambleScatter: {
    position: [2, 3],
    value: 8,
    tier: 3,
    variants: [
      [12, 4],
      [16, 5],
    ],
  },
  storage: {
    mystery_feature: { coords: DEV_REROLL_COORDS, replacement: "10" },
    gamble_scatter_values: [[2, 3], 8, 3],
    coins_feature: DEV_REROLL_AWARD_COINS_FEATURE,
  },
  id: `test-dev-golden-reroll-award-${Date.now()}`,
};


export const DEV_WIN_TRIGGER_MULTIPLIER = 8;

const DEV_WT_BET = 10;

// 4 = m3, a mid pay. Reels 3 and 4 hold symbols that cannot extend the line,
// so the two wins are exactly three-of-a-kind and stop where they should.
const DEV_WT_SCREEN = [
  [4, 4, 4, 6, 6, 6],
  [11, 4, 4, 7, 7, 7],
  [11, 4, 4, 8, 8, 8],
  [12, 5, 5, 1, 1, 1],
  [6, 6, 7, 7, 8, 8],
];

// Straight lines: id N is the line along row N, the same mapping every other
// round in this file uses.
const DEV_WT_WIN_LINES = [
  { lineId: 1, rows: [1, 1, 1] },
  { lineId: 2, rows: [2, 2, 2] },
];

// The three that trigger. SC, SC, then SC1 LAST — buildGambleScatterReveal
// reads the final entry as SC1's position, and the live RGS builds the list in
// this order.
const DEV_WT_SCATTER_POSITIONS = [
  [1, 0],
  [2, 0],
  [3, 0],
];

// A real package, so the strip lands on something and hands off to the Gamble
// Round: 8 spins at tier 3, with two rungs still on the ladder above it.
const DEV_WT_GAMBLE_SCATTER = {
  position: [3, 0],
  value: 8,
  tier: 3,
  variants: [
    [12, 4],
    [16, 5],
  ],
};

export const DEV_WIN_TRIGGER_ROUND = {
  bet: DEV_WT_BET,
  reels: DEV_WT_SCREEN,
  wins: [
    ...DEV_WT_WIN_LINES.map(({ lineId, rows }) => ({
      id: lineId,
      win: 0, // rescaled per spin in gameSettingsSlice — see the branch there
      positions: rows.map((row, reelIndex) => [reelIndex, row]),
      symbol: 4,
    })),
    // The synthetic scatter win the RGS injects on a real trigger. Pays 0 and
    // exists for the show: its positions are what useWinController walks to
    // find the cells that must reveal.
    {
      id: null,
      win: 0,
      positions: DEV_WT_SCATTER_POSITIONS,
      symbol: null,
      isScatter: true,
    },
  ],
  win: 0, // rescaled per spin
  // Left to computeWinType so changing the stake re-tiers it honestly.
  winType: "",
  isAnimatedWin: false,
  // THE GATE — useWinController returns immediately without it.
  triggerWin: true,
  // The doors are owed to SC1. Without this the scatters land and nothing ever
  // opens.
  triggerReveal: true,
  gambleScatter: DEV_WT_GAMBLE_SCATTER,
  id: `test-dev-win-trigger-${Date.now()}`,
};

/**
 * The `freeSpinsTrigger` payload a simulated AWARD must carry.
 *
 * ── Why this exists, and why it is not a hack ──
 *
 * The gameSettingsSlice injection replaces `state.currentRound` and nothing
 * else, so every OTHER slice still sees the real server response. freeSpinsSlice
 * is the one that matters here: it sets `triggered` from
 * `action.payload.freeSpinsTrigger`, and useWinController reads exactly that
 * flag to decide between playing the lines once and ending on the scatters, or
 * cycling them for ever.
 *
 * So a simulated award played the right board and then cycled endlessly — not
 * because the presentation was wrong, but because the simulation could not say
 * a round had triggered. This is the payload the RGS emits, in the RGS's own
 * shape (see `freeSpinsTrigger` in PopiPlay/RGS), so the slice cannot tell the
 * difference and no production path learns about the simulation.
 *
 * Patched into the thunk's RESULT rather than into a reducer, so `round` and
 * `freeSpinsTrigger` arrive together and every listener sees one consistent
 * response — which is what the real thing does.
 *
 * @returns {object|null} null whenever the simulation is off or the mode is not
 *          one that awards, so the live payload passes through untouched.
 */
// ── EVERY mode whose round awards a package ─────────────────────────────────
//
// One table instead of a chain of `if`s, because the chain is how a new
// awarding round gets forgotten — and a forgotten one does not fail loudly. It
// plays the whole feature, dims the board, and then stands there for ever with
// the win on the counter and nothing moving, which reads as a broken
// presentation rather than a missing three-line patch. `golden_reroll_award`
// did exactly that on 2026-09-22.
//
// The rule is simply: a round with a `gambleScatter` that awards must appear
// here. `devSimulationTriggerModes` is exported so a test can hold the file to
// it rather than trusting anyone to remember.
const DEV_TRIGGER_ROUNDS = {
  win_trigger: DEV_WIN_TRIGGER_ROUND,
  golden_award: DEV_GOLDEN_AWARD_ROUND,
  golden_reroll_award: DEV_GOLDEN_REROLL_AWARD_ROUND,
  // Found by the test below, 2026-09-22, not by anyone running it: its round
  // carries a real package (DEV_GAMBLE_SCATTER) and it was never in this list,
  // so it hung after the reveal exactly as the new round did. Added because the
  // rule is the rule — a round that awards must be able to hand off.
  scatter_trigger: DEV_SCATTER_TRIGGER_ROUND,
};

/** The modes that emit a trigger, for the test that checks none are missing. */
export const devSimulationTriggerModes = () => Object.keys(DEV_TRIGGER_ROUNDS);

/** The round a trigger mode plays, so a test can match rounds to modes. */
export const devSimulationTriggerRound = (mode) =>
  DEV_TRIGGER_ROUNDS[mode] ?? null;

export const devSimulationSpinPatch = () => {
  if (!DEV_SIMULATION_ENABLED) return null;

  // The board the room opens on — freeSpinsSlice reads it for the arrival
  // screen, and the scatters that won have to still be standing there.
  const round = DEV_TRIGGER_ROUNDS[DEV_SIMULATION_MODE];
  if (!round) return null;

  const reveal = round.gambleScatter;
  return {
    round,
    freeSpinsTrigger: {
      spins: reveal?.value ?? 0,
      tier: reveal?.tier ?? null,
      reveal,
    },
  };
};

// ── The round ───────────────────────────────────────────────────────────────
// A REAL PopiPlay spin response (round 1415419), written in the shape the RGS
// ADAPTER produces — because the simulation replaces state.currentRound
// directly and therefore never passes through the adapter.
//
// What the adapter does, and so what is reproduced here:
//
//   outcome.screen -> reels     strings parsed to numbers, reel order kept
//   outcome.wins   -> wins      ["line", amount, rows, lineId] becomes
//                               { id, win, positions, symbol }, rows mapped
//                               to [reelIndex, row]
//   outcome.win    -> win
//                  -> winType       computeWinType(win, bet)
//                  -> isAnimatedWin winType is in ANIMATED_WIN_TYPES
//                  -> triggerWin    win > 0 || bonus trigger
//
// triggerWin is the one that is easy to miss and the reason an earlier version
// of this file played nothing: useWinController gates the ENTIRE celebration
// on it — `if (!currentRound?.triggerWin || !winningLines) return;` — so a
// round without it is silent no matter how large the win.
//
// The original response paid 4000 on a bet of 10000, which is 0.4x and no
// celebration at all. The amounts below are scaled to DEV_WIN_MULTIPLIER
// instead, and the slice rescales again to whatever stake is selected.
const DEV_BET = 10000;
const DEV_WIN = DEV_BET * DEV_WIN_MULTIPLIER;

// outcome.screen, parsed. Five reels, six rows, top to bottom.
// The 0 on reel 4 is the wild the response reported at [4, 3].
// (Mad Labs' 5x6 board — replaced by Cleopatra's below.)
// const DEV_SCREEN = [
//   [3, 3, 6, 6, 6, 6],
//   [8, 8, 6, 6, 6, 6],
//   [3, 3, 3, 3, 3, 6],
//   [1, 1, 1, 1, 1, 5],
//   [8, 8, 8, 0, 8, 8],
// ];
// CLEOPATRA'S FIRE (2026-09-30, for the win celebrations): 5 reels x 4 rows,
// top to bottom. h1 (1) across the middle two rows, a wild (0) on reel 3,
// low pays (5–8) on the top and bottom rows.
const DEV_SCREEN = [
  [5, 1, 1, 6],
  [7, 1, 1, 8],
  [6, 1, 0, 5],
  [8, 1, 1, 7],
  [5, 1, 1, 6],
];

// outcome.wins — ["line", amount, rowsPerReel, lineId].
// rowsPerReel[i] is the row the line sits on for reel i, so [5, 5, 5] becomes
// [[0,5], [1,5], [2,5]]: a three-of-a-kind across the first three reels.
// These are the four lines the real round paid.
// const DEV_WIN_LINES = [
//   { lineId: 5, rows: [5, 5, 5] },
//   { lineId: 9, rows: [3, 4, 5] },
//   { lineId: 18, rows: [4, 5, 5] },
//   { lineId: 37, rows: [5, 4, 5] },
// ];
// Cleopatra's: three five-of-a-kind h1 lines on the board above — row 1,
// row 2 (through the wild), and a V between them. The 65x is split evenly.
const DEV_WIN_LINES = [
  { lineId: 1, rows: [1, 1, 1, 1, 1] },
  { lineId: 2, rows: [2, 2, 2, 2, 2] },
  { lineId: 3, rows: [1, 2, 2, 2, 1] },
];

// Same rule the adapter uses: a line's symbol is the first non-wild cell under
// it, falling back to the first cell when the line is all wilds.
const resolveLineSymbol = (rows) => {
  for (let reel = 0; reel < rows.length; reel++) {
    const symbol = DEV_SCREEN[reel]?.[rows[reel]];
    if (symbol !== undefined && symbol !== WILD_ID) return symbol;
  }
  return DEV_SCREEN[0]?.[rows[0]] ?? null;
};

export const DEV_SIMULATION_ROUND = {
  // Exactly the fields a stored round carries — nothing else is needed.
  bet: DEV_BET,
  reels: DEV_SCREEN,
  wins: DEV_WIN_LINES.map(({ lineId, rows }) => ({
    id: lineId,
    win: Math.round(DEV_WIN / DEV_WIN_LINES.length),
    positions: rows.map((row, reelIndex) => [reelIndex, row]),
    symbol: resolveLineSymbol(rows),
  })),
  win: DEV_WIN,
  winType: "supermega_win",
  isAnimatedWin: true,
  // THE GATE — useWinController returns early without it and plays nothing.
  triggerWin: true,
  // Not in a stored round, but the slice replaces it per spin anyway: the win
  // controller dedupes on `${round.id}-${winsHash}`, and a round with neither
  // a changing id nor changing wins animates once and is skipped for ever.
  id: `test-dev-sim-${Date.now()}`,
};
